module.exports = __webpack_public_path__ + "media/Mother-Earth-song-2.167e231e.mp3";